module.exports = __webpack_public_path__ + "img/gaviotas.3ab9e285.gif";